import React from 'react';
import { useHistory } from 'react-router';
import { BusinessUnit, Stretches } from '../@types/Data';

interface CardStretchProps {
    stretch: Stretches,
    imagen: string,
    id_operationLine: number, 
    businessUnit?: BusinessUnit
}

export const CardStretch: React.FC<CardStretchProps> = ({stretch, imagen, id_operationLine, businessUnit}) => {
    const history = useHistory();
    const openTrayecto = () => {
        history.push(`/trayecto/${stretch.id}/${id_operationLine}`);
    }

    return(
        <div className="col-md-6">
            <div className="destinations-three__single"style={{ backgroundImage: `url(${imagen})` }}>
                    <div className="destinations-three__content">
                        <h3><a href="#" onClick={openTrayecto}>{stretch.name}</a></h3>
                    </div>

                    <div className="destinations-three__hover-content">
                        <h3><a href="#" onClick={openTrayecto}>{stretch.name}</a></h3>
                        <p>{stretch.description}</p>
                        <a href="#" onClick={openTrayecto} className="destinations-three__link"><i className="fa fa-arrow-right"></i></a>
                    </div>
            </div>

        </div>

    );
}
